﻿<template>

    <h6>{{trip.tour_name}} {{Departure_Date()}}</h6>

    <div class="overflow-x-auto">
        <div class="grid grid-cols-4 p-2 m-2 min-w-max">
            <div></div>
            <div class="text-right font-bold">Commission</div>
            <div class="text-right font-bold">Price</div>
            <div class="text-right font-bold">Cancel</div>
            <booking_line_passenger :trip_passenger="trip_passenger" v-for="trip_passenger in trip.passengers"></booking_line_passenger>
        </div>
    </div>

</template>

<script lang="ts" src="./booking_line.ts"></script>